module.exports = __webpack_public_path__ + "static/IMG_4681-83b113d08d24bb758d8f949edcc2c809.png";